var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.34315 3.34315 2 5 2H8C9.65685 2 11 3.34315 11 5V8C11 9.65685 9.65685 11 8 11H5C3.34315 11 2 9.65685 2 8V5Z",
    fill: "#181A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16C2 14.3431 3.34315 13 5 13H8C9.65685 13 11 14.3431 11 16V19C11 20.6569 9.65685 22 8 22H5C3.34315 22 2 20.6569 2 19V16Z",
    fill: "#181A1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5C13 3.34315 14.3431 2 16 2H19C20.6569 2 22 3.34315 22 5V8C22 9.65685 20.6569 11 19 11H16C14.3431 11 13 9.65685 13 8V5Z",
    fill: "#181A1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 14C18 13.4477 17.5523 13 17 13C16.4477 13 16 13.4477 16 14V16H14C13.4477 16 13 16.4477 13 17C13 17.5523 13.4477 18 14 18H16V20C16 20.5523 16.4477 21 17 21C17.5523 21 18 20.5523 18 20V18H20C20.5523 18 21 17.5523 21 17C21 16.4477 20.5523 16 20 16H18V14Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.21b619e3625259f5bbe151e932be406e.svg";
export { ForwardRef as ReactComponent };